/**
 * @external https://mui.com/components/data-grid/getting-started/#license-key-installation
 */
import { LicenseInfo } from '@mui/x-data-grid-pro';
import config from './appConfig';

LicenseInfo.setLicenseKey(config.muiLicenseKey || '');
